module.exports = __webpack_public_path__ + "static/media/Windows.0691e1f6.svg";